import { Flex, CheckboxGroup, Spinner, TextInput, DatePicker, Text } from '@applyboard/crystal-ui';
import { ConditionType, useOfferConditions } from '../../../../data/useOfferConditions';
import { OfferClassification } from '../types';
import { OfferClassificationCard } from '../../components/OfferClassificationCard';

export function ConditionGroup(props: {
  conditionType: ConditionType;
  setConditions: (conditions: Array<string>) => void;
  conditions: Array<string>;
  setCustomCondition: (condition: string) => void;
  customCondition: string;
  enableConditionDeadline: boolean;
  conditionDeadline?: string;
  setConditionDeadline?: (date: string) => void;
  offerClassification: OfferClassification | '';
  setOfferClassification: (classification: OfferClassification) => void;
}) {
  const { conditions: remoteConditions, isFetchingCondition } = useOfferConditions(props.conditionType);
  const minDate = new Date();
  minDate.setDate(minDate.getDate() - 1);

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 15);

  const isConditional = props.offerClassification === OfferClassification.CONDITIONAL;

  return (
    <>
      <Flex direction="column" gap={2}>
        <Text variant="bodyS" contrast="mid">
          Offer Type{' '}
          <Text as="span" aria-hidden intent="negative" variant="labelM" contrast="mid">
            *
          </Text>
        </Text>
        <Flex direction="row" gap={4}>
          <OfferClassificationCard
            selected={props.offerClassification === OfferClassification.UNCONDITIONAL}
            title="Unconditional"
            subtitle="No additional requirements"
            onClick={() => props.setOfferClassification(OfferClassification.UNCONDITIONAL)}
            aria-label="Unconditional offer type"
          />
          <OfferClassificationCard
            selected={props.offerClassification === OfferClassification.CONDITIONAL}
            title="Conditional"
            subtitle="Student must meet requirements"
            onClick={() => props.setOfferClassification(OfferClassification.CONDITIONAL)}
            aria-label="Conditional offer type"
          />
        </Flex>
      </Flex>
      {isConditional &&
        (isFetchingCondition ? (
          <Flex direction="column" align="center">
            <Spinner />
          </Flex>
        ) : (
          <>
            <CheckboxGroup
              onChange={(conditions: Array<string>) => {
                props.setConditions(conditions);
              }}
              value={props.conditions}
              label="Select Applicable Conditions"
            >
              <Flex direction="column">
                {remoteConditions?.map((i) => (
                  <CheckboxGroup.Option label={i.name} value={i.code} key={i.id} aria-label={i.name} />
                ))}
              </Flex>
            </CheckboxGroup>
            <TextInput
              label="Custom condition"
              intent="secondary"
              onChange={(condition: string) => props.setCustomCondition(condition)}
              value={props.customCondition}
              helpText="Add any conditions that are not included in the list above"
              aria-label="Custom condition"
            />
            {props.enableConditionDeadline && (
              <DatePicker
                granularity="day"
                label="Condition Deadline"
                maxDate={maxDate.toISOString()}
                minDate={minDate.toISOString()}
                onChange={(date: string) => props.setConditionDeadline && props.setConditionDeadline(date)}
                size="md"
                value={props.conditionDeadline ? props.conditionDeadline : ''}
                aria-label="Condition Deadline"
              />
            )}
          </>
        ))}
    </>
  );
}
